var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83442 11.0374L5.42779 13.219L4.3 14.98C3.73706 14.6807 3.35665 14.5851 3.15877 14.6933C2.96089 14.8016 2.76361 14.9865 2.56691 15.2482H0.592082C0.42865 15.2482 0.336163 15.0641 0.438669 14.9368C0.842725 14.435 1.20428 14.0828 1.20548 13.83C1.20692 13.5278 1.19781 13.1806 0.706632 12.7984L1.83442 11.0374ZM8.87401 0.818568L11.4423 2.44527C11.7253 2.59849 11.8223 2.93783 11.6589 3.20321L5.88532 12.4265L2.29195 10.2449L8.06551 1.02166C8.22895 0.756277 8.59093 0.665351 8.87401 0.818568Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.a7a1d5e4e85054da70b813fde8717f10.svg";
export { ForwardRef as ReactComponent };